import React, {Component} from 'react';
import './ArrowLink.css';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import Cappy from "../Etc/Cappy";

export default class ArrowLink extends Component {
    render() {
        let classNames = ["ArrowLink"];

        if (this.props.reverse) {
            classNames.push("ArrowLink--reverse");
        }

        let preIcon = null;
        let postIcon = null;

        if (this.props.reverse) {
            preIcon = <i className="ArrowLink__arrow mdi mdi-arrow-left"/>;
            postIcon = this.props.icon || (null);
        } else {
            preIcon = this.props.icon || (null);
            postIcon = <i className="ArrowLink__arrow mdi mdi-arrow-right"/>;
        }

        if (this.props.routerLink) {
            return (
                <Link className={classNames.join(' ')} title={this.props.label} to={this.props.to || this.props.href}>
                    {preIcon}
                    <span>{this.props.label}</span>
                    {postIcon}
                </Link>
            );
        }

        if (this.props.className) {
            classNames.push(this.props.className);
        }

        return (
            <a className={classNames.join(' ')} title={this.props.label} href={this.props.href || null}
               target={this.props.target && this.props.target !== "_self" ? this.props.target : null} onClick={this.props.onClick || null}>
                {preIcon}
                <span>{Cappy.onlyFirst(this.props.label)}</span>
                {postIcon}
            </a>
        );
    }
}

ArrowLink.propTypes = {
    label: PropTypes.string.isRequired,
    href: PropTypes.string,
    onClick: PropTypes.func,
    target: PropTypes.string,
    routerLink: PropTypes.bool,
    reverse: PropTypes.bool,
    icon: PropTypes.any,
    className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/Common/ArrowLink.js